function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var LoungeOverlay = require('./overlays/lounge');
var InviteTemplate = require('./invite.template');
var InviteTemplateSparse = require('./invite.template.sparse');
var JSON = require('json-bigint');

/**
 * Derive invite-card economic line and risk-mode ribbon from invite options.
 * Uses the same stake object shape as game creation (symmetric amount or
 * { min, [publicKey]: amount } for asymmetric / creator-funded games).
 */
function deriveEconomicInviteDisplay() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var originator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var empty = {
    economic_line: null,
    risk_mode: null
  };
  if (!(options !== null && options !== void 0 && options.crypto)) {
    return empty;
  }
  var ticker = options.crypto;
  var stake = options.stake;
  if (stake === undefined || stake === null || stake === '') {
    return empty;
  }
  if (_typeof(stake) === 'object') {
    var min = parseFloat(stake.min);
    if (Number.isNaN(min)) {
      return empty;
    }
    var max = min;
    for (var key in stake) {
      if (key === 'min') {
        continue;
      }
      var value = parseFloat(stake[key]);
      if (!Number.isNaN(value) && value > max) {
        max = value;
      }
    }

    // Joiners must match at least `min`; min === 0 means creator-funded prize.
    var joiner_must_contribute = min > 0;
    var risk_mode = 'RISK FREE';
    if (joiner_must_contribute) {
      risk_mode = min === max ? 'EVEN BETS' : 'CUSTOM BETS';
    }
    var amount_label;
    if (joiner_must_contribute) {
      amount_label = min === max ? String(min) : "".concat(min, " - ").concat(max);
    } else {
      if (originator && stake[originator] != null && stake[originator] !== '') {
        amount_label = String(stake[originator]);
      } else {
        amount_label = String(max);
      }
    }
    return {
      economic_line: "".concat(amount_label, " ").concat(ticker),
      risk_mode: risk_mode
    };
  }
  var amount = parseFloat(stake);
  if (Number.isNaN(amount) || amount <= 0) {
    return empty;
  }
  return {
    economic_line: "".concat(stake, " ").concat(ticker),
    risk_mode: 'EVEN BETS'
  };
}
var Invite = /*#__PURE__*/function () {
  function Invite(app, mod, container, type) {
    var tx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var publicKey = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
    _classCallCheck(this, Invite);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.type = type;

    //
    // information may be stored in different places, so we
    // save these variables in our invite, and use the invite
    // version to display our overlay templates.
    //
    this.invite_data = {
      tx: tx,
      game_id: '',
      game_name: '',
      invite_type: '',
      game_status: '',
      originator: null,
      players: [],
      players_needed: 0,
      desired_opponent_publickeys: [],
      options: {},
      game_mod: null,
      game_slug: '',
      game_type: 'standard game',
      winner: '',
      method: '',
      time_created: 0,
      time_finished: 0,
      target: 0
    };

    //
    // if we have a valid tx, parse the data, so that the UI components have easy access to info to render
    //
    if (tx) {
      var _txmsg$options, _txmsg$options2, _txmsg$options3;
      var txmsg = tx.returnMessage();
      this.invite_data.game_id = tx.signature;
      this.invite_data.game_name = txmsg.game;
      this.invite_data.invite_type = txmsg.request;
      this.invite_data.originator = txmsg.originator;
      this.invite_data.players = txmsg.players;
      this.invite_data.players_needed = txmsg.players_needed;
      this.invite_data.time_created = tx.timestamp;
      if (txmsg.winner) {
        this.invite_data.winner = txmsg.winner;
      }
      if (txmsg.method) {
        this.invite_data.method = txmsg.method;
      }
      if (txmsg.time_finished) {
        this.invite_data.time_finished = txmsg.time_finished;
      }
      if (txmsg.step) {
        this.invite_data.step = txmsg.step;
      }
      if (txmsg.timestamp) {
        this.invite_data.timestamp = txmsg.timestamp;
      }
      var alt_game_type = '';
      //We still don't know the exact data structures for specified invite(s)
      //But it isn't going to be a single string pushed into an array!
      if ((_txmsg$options = txmsg.options) !== null && _txmsg$options !== void 0 && _txmsg$options.desired_opponent_publickey) {
        if (!this.invite_data.players.includes(txmsg.options.desired_opponent_publickey)) {
          this.invite_data.desired_opponent_publickeys.push(txmsg.options.desired_opponent_publickey);
        }

        //Invitation / Challenge ?

        if (publicKey == txmsg.options.desired_opponent_publickey) {
          alt_game_type = 'direct ';
          this.invite_data.game_type = 'direct ';
        }
      }
      this.invite_data.options = txmsg.options;
      var game_mod = app.modules.returnModule(txmsg.game);
      if (game_mod) {
        this.invite_data.game_mod = game_mod;
        this.invite_data.game_slug = game_mod.returnSlug();
        this.invite_data.game_name = game_mod.returnName();
      } else {
        this.invite_data.game_slug = this.invite_data.game_name.toLowerCase();
      }

      //
      //Figure out what kind of game invite for convenient display
      //

      //Custom Game

      if (game_mod) {
        var defaultOptions = game_mod.returnDefaultGameOptions();
        var inviteKeys = Object.keys(txmsg.options);
        for (var _i = 0, _inviteKeys = inviteKeys; _i < _inviteKeys.length; _i++) {
          var key = _inviteKeys[_i];
          if (key !== 'desired_opponent_publickey' && !key.includes('game-wizard-players') && key !== 'eliminated' && key !== 'open-table') {
            if (!defaultOptions[key] || defaultOptions[key] != txmsg.options[key]) {
              alt_game_type += 'custom ';
              this.invite_data.game_type = 'custom game';
              break;
            }
          }
        }
        if (this.invite_data.game_type == 'custom game') {
          console.debug('ARCADE invite option analysis: ', defaultOptions, txmsg.options);
        }
      }
      if (txmsg.options['open-table']) {
        alt_game_type += 'open table ';
        this.invite_data.game_type = 'open table ';
      }

      //Crypto Game
      if ((_txmsg$options2 = txmsg.options) !== null && _txmsg$options2 !== void 0 && _txmsg$options2.crypto) {
        alt_game_type += txmsg.options.crypto + ' ';
        this.invite_data.game_type = "".concat(txmsg.options.crypto, " game");
        if (txmsg.options['open-table']) {
          this.invite_data.game_type = "open ".concat(txmsg.options.crypto, " table");
        }
        var economic = deriveEconomicInviteDisplay(txmsg.options, txmsg.originator);
        this.invite_data.economic_line = economic.economic_line;
        this.invite_data.risk_mode = economic.risk_mode;
      }

      //League

      if ((_txmsg$options3 = txmsg.options) !== null && _txmsg$options3 !== void 0 && _txmsg$options3.league_id) {
        this.invite_data.league = txmsg.options.league_id;
        alt_game_type += 'league ';
        this.invite_data.game_type = 'league game';
      }

      //Private (only shown to the originator)
      if (txmsg.request === 'private') {
        alt_game_type += 'private ';
        this.invite_data.game_type = 'private game';
      }
      alt_game_type += 'game';
      if (alt_game_type == 'game') {
        this.invite_data.verbose_game_type = 'standard game open';
      } else {
        this.invite_data.verbose_game_type = alt_game_type;
      }
      this.invite_data.verbose_game_type += ' invitation';
      if (txmsg.options['game-wizard-players-select-max'] && txmsg.options['open-table']) {
        this.invite_data.max_players = parseInt(txmsg.options['game-wizard-players-select-max']);
      }

      // tentative (pending) roster changes ride on the invite message
      this.invite_data.tentative = txmsg.tentative || {
        join: [],
        leave: []
      };
    }

    // calculate empty slots
    this.invite_data.empty_slots = 0;
    this.invite_data.empty_slots = Math.max(0, this.invite_data.players_needed - this.invite_data.players.length);
    if (!this.mod.isMyGame(tx)) {
      if (!this.invite_data.empty_slots && this.invite_data.max_players && !this.invite_data.time_finished) {
        var _this$invite_data$ten;
        //
        // pending joiners occupy future seats -- count them so we never invite
        // someone to join a table that is (or is about to be) full. pending
        // leavers stay counted until they actually leave.
        //
        var pending = ((_this$invite_data$ten = this.invite_data.tentative) === null || _this$invite_data$ten === void 0 || (_this$invite_data$ten = _this$invite_data$ten.join) === null || _this$invite_data$ten === void 0 ? void 0 : _this$invite_data$ten.length) || 0;
        this.invite_data.empty_slots = Math.max(0, this.invite_data.max_players - this.invite_data.players.length - pending);
        if (this.invite_data.empty_slots) {
          this.invite_data.empty_slots = 1;
        }
      }
    }

    // remove empty slots if any players are requested
    // because we will pre-fill in the invitees
    this.invite_data.empty_slots -= this.invite_data.desired_opponent_publickeys.length;

    //if this game already exists!
    for (var i = 0; i < ((_this$app = this.app) === null || _this$app === void 0 || (_this$app = _this$app.options) === null || _this$app === void 0 || (_this$app = _this$app.games) === null || _this$app === void 0 ? void 0 : _this$app.length); i++) {
      var _this$app;
      if (this.app.options.games[i].id == this.invite_data.game_id) {
        this.invite_data.target = this.app.options.games[i].target;
        if (this.app.options.games[i].players) {
          this.invite_data.players = this.app.options.games[i].players;
        }
        this.invite_data.game_status = this.app.browser.stripHtml(this.app.options.games[i].status);
      }
    }
  }
  return _createClass(Invite, [{
    key: "render",
    value: function render() {
      var html = '';
      if (this.type == 'sparse') {
        html = InviteTemplateSparse(this.app, this.mod, this.invite_data);
      } else {
        html = InviteTemplate(this.app, this.mod, this.invite_data);
      }
      if (this.container && document.querySelector(this.container)) {
        this.app.browser.addElementToSelector(html, this.container);
      } else {
        this.app.browser.replaceElementBySelector(html, '.arcade-invites');
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var qs = "".concat(this.container, " #arcade-invite-").concat(this.invite_data.game_id).trim();
      if (!this.container) {
        qs = "#arcade-invite-".concat(this.invite_data.game_id);
      }
      try {
        if (document.querySelector(qs)) {
          document.querySelector(qs).onclick = function (e) {
            e.stopImmediatePropagation();
            var game_overlay = new LoungeOverlay(_this.app, _this.mod, _this.invite_data);
            game_overlay.render();
          };
        }
      } catch (err) {
        console.error(err);
      }
    }
  }]);
}();
module.exports = Invite;